// extracted by mini-css-extract-plugin
export default {"content":"WhiteBoxPage_content__muWyn","bredCrumbs_block":"WhiteBoxPage_bredCrumbs_block__-pp0k"};